import React, { useState, useEffect } from 'react';
import { LogOut, BarChart3, FileText, CheckCircle, Users, Key, Handshake } from 'lucide-react';
import { Button } from './ui/button';
import { DashboardParcerias } from './Parcerias';
import { RegistoVales } from './Parcerias';
import { GestaoUtilizadoresParceria } from './Parcerias';
import MinhaParceria from './Parcerias/MinhaParceria';
import MinhaContaTab from './MinhaContaTab';
import api from '../services/api';

const ParceriaDashboardPage = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('minha-parceria');
  const [nomeParceria, setNomeParceria] = useState('');
  const isAdmin = user.role === 'admin_parceria';

  useEffect(() => {
    loadNomeParceria();
  }, []);

  const loadNomeParceria = async () => {
    try {
      const resp = await api.get('/parcerias/dashboard/parceria');
      setNomeParceria(resp.data.nome_parceria || 'Parceria');
    } catch {
      setNomeParceria('Parceria');
    }
  };

  const tabs = [
    { id: 'minha-parceria', label: 'A Minha Parceria', icon: Handshake, roles: ['admin_parceria', 'colaborador_parceria'] },
    { id: 'registar', label: 'Registar Vale', icon: FileText, roles: ['admin_parceria', 'colaborador_parceria'] },
    { id: 'validar', label: 'Validar Vale', icon: CheckCircle, roles: ['admin_parceria', 'colaborador_parceria'] },
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3, roles: ['admin_parceria'] },
    { id: 'utilizadores', label: 'Utilizadores', icon: Users, roles: ['admin_parceria'] },
    { id: 'minha-conta', label: 'Minha Conta', icon: Key, roles: ['admin_parceria', 'colaborador_parceria'] },
  ];

  const visibleTabs = tabs.filter(t => t.roles.includes(user.role));

  return (
    <div className="min-h-screen bg-gray-50" data-testid="parceria-dashboard-page">
      <header className="bg-white border-b shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center">
              <span className="text-foreground font-bold text-sm">P</span>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-gray-800" data-testid="parceria-nome">{nomeParceria}</h1>
              <p className="text-xs text-muted-foreground">{user.nome} - {isAdmin ? 'Administrador' : 'Colaborador'}</p>
            </div>
          </div>
          <Button variant="outline" size="sm" onClick={onLogout} data-testid="logout-btn">
            <LogOut className="h-4 w-4 mr-2" />
            Sair
          </Button>
        </div>
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 pb-2 flex gap-1 overflow-x-auto">
          {visibleTabs.map(tab => (
            <Button
              key={tab.id}
              variant={activeTab === tab.id ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setActiveTab(tab.id)}
              data-testid={`tab-${tab.id}`}
              className="whitespace-nowrap"
            >
              <tab.icon className="h-4 w-4 mr-1.5" />
              {tab.label}
            </Button>
          ))}
        </nav>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        {activeTab === 'minha-parceria' && <MinhaParceria />}
        {activeTab === 'dashboard' && <DashboardParcerias user={user} />}
        {activeTab === 'registar' && <RegistoVales user={user} modo="registar" />}
        {activeTab === 'validar' && <RegistoVales user={user} modo="validar" />}
        {activeTab === 'utilizadores' && isAdmin && <GestaoUtilizadoresParceria user={user} />}
        {activeTab === 'minha-conta' && <MinhaContaTab />}
      </main>
    </div>
  );
};

export default ParceriaDashboardPage;
